import {
    FortuneTab,
    FortuneTabItem,
    FortuneWrap
} from "src/styles/views/UserPage/Fortune"
import {useState} from "react"
import {COLOR} from "src/service/constant/color"
import HoroscopeFortune from "src/component/UserPage/Fortune/HoroscopeFortune"
import BirthDayFortune from "src/component/UserPage/Fortune/BirthDayFortune"



type tabListType = {
    idx: number,
    text: string,
    component: JSX.Element

}
const tabList: tabListType[] = [
    {idx: 0, text: '오늘의 운세', component: <BirthDayFortune/>},
    {idx: 1, text: '오늘의 띠별운세', component: <HoroscopeFortune/>},
]
const UserPageFortune = () => {
    const [tabChange, setTabChange] = useState(0)
    const FindItem = (element: any) => {
        return element.idx === tabChange
    }

    return (
        <FortuneWrap>
            <FortuneTab>
                {tabList.map((option: { idx: number, text: string }) => (
                    <FortuneTabItem
                        color={option.idx === tabChange ? COLOR.black : COLOR.blueGray2} key={option.idx}
                        onClick={() => setTabChange(option.idx)}>
                        {option.text}
                    </FortuneTabItem>
                ))}
            </FortuneTab>
            {tabList?.find(FindItem)?.component}
        </FortuneWrap>
    )
}
export default UserPageFortune